const CutDrySyncStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
};

const CUT_DRY_SYNC_STATUS_OPTIONS = [
  { value: CutDrySyncStatus.COMPLETED, label: 'Completed' },
  { value: CutDrySyncStatus.FAILED, label: 'Failed' },
  { value: CutDrySyncStatus.IN_PROGRESS, label: 'In Progress' },
];

export default CutDrySyncStatus;
export { CUT_DRY_SYNC_STATUS_OPTIONS };
